module.exports = __webpack_public_path__ + "img/MB_hoe.53cdd9d0.png";